/**
 * News Sidebar - Layout permanente em "L"
 * Carrega notícias automaticamente ao abrir a página
 * Pode ser recolhida/expandida via toggle
 */

document.addEventListener('DOMContentLoaded', function () {
    const newsSidebar = document.getElementById('news-sidebar');
    const newsListContainer = document.getElementById('news-list');

    if (!newsSidebar) {
        console.warn('News sidebar not found');
        return;
    }

    // Load news on page load
    loadNews();

    async function loadNews() {
        try {
            newsListContainer.innerHTML = `
                <div class="loading-spinner">
                    <div class="spinner"></div>
                    <p>Carregando notícias...</p>
                </div>
            `;

            const baseUrl = document.querySelector('base')?.href || window.location.origin + '/index.php/';
            const origin = window.location.origin + '/';

            function imgUrl(coverImage) {
                if (!coverImage) return origin + 'assets/images/blog/blog-placeholder.svg';
                if (coverImage.indexOf('http') === 0) return coverImage;
                return origin + coverImage;
            }

            const response = await fetch(baseUrl + 'api/noticias');

            if (!response.ok) {
                throw new Error('Failed to load news');
            }

            const data = await response.json();

            if (data.news && data.news.length > 0) {
                let newsHTML = '';
                data.news.forEach(article => {
                    const date = new Date(article.created_at);
                    const formattedDate = date.toLocaleDateString('pt-BR');
                    const excerpt = article.excerpt.substring(0, 80) + '...';
                    const noticeUrl = baseUrl + 'noticias/' + article.slug;

                    var imgSrc = imgUrl(article.cover_image);
                    newsHTML += `
                        <a href="${noticeUrl}" style="text-decoration: none; color: inherit; display: block;">
                            <article class="news-item">
                                <div class="news-item-inner">
                                    <div class="news-item-thumb">
                                        <img src="${imgSrc}" alt="${article.title}" loading="lazy">
                                    </div>
                                    <div class="news-item-body">
                                        <h3 class="news-item-title">${article.title}</h3>
                                        <p class="news-item-excerpt">${excerpt}</p>
                                        <div class="news-item-meta">
                                            <span class="meta-date-icon">
                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                                    <circle cx="12" cy="7" r="4"></circle>
                                                </svg>
                                                ${formattedDate}
                                            </span>
                                            <span class="meta-views-icon">
                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                                    <path d="M2.344 12.4c2.063-4.226 5.59-7.2 9.656-7.2 4.067 0 7.594 2.974 9.657 7.2"></path>
                                                    <path d="M21.657 12.4c-2.063 4.226-5.59 7.2-9.657 7.2-4.066 0-7.593-2.974-9.656-7.2"></path>
                                                    <circle cx="12" cy="12" r="2.5"></circle>
                                                </svg>
                                                ${article.view_count || 0}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </a>
                    `;
                });
                newsListContainer.innerHTML = newsHTML;
            } else {
                newsListContainer.innerHTML = `
                    <div class="empty-state">
                        <div class="empty-state-icon">
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.4">
                                <path d="M4 4h16v2H4V4m0 4h16v10H4V8m0 12h16v2H4v-2"></path>
                            </svg>
                        </div>
                        <p>Nenhuma notícia disponível no momento</p>
                    </div>
                `;
            }
        } catch (error) {
            console.error('Error loading news:', error);
            newsListContainer.innerHTML = `
                <div class="empty-state">
                    <div class="empty-state-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.4">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="8" x2="12" y2="12"></line>
                            <line x1="12" y1="16" x2="12.01" y2="16"></line>
                        </svg>
                    </div>
                    <p>Em breve!</p>
                </div>
            `;
        }
    }

    // Toggle sidebar visibility
    function toggleNewsSidebar() {
        newsSidebar.classList.toggle('closed');
    }

    // Toggle transparency on scroll (matches navigation behavior)
    function handleScrollTransparency() {
        if (window.scrollY > 50) {
            newsSidebar.classList.add('is-scrolled');
        } else {
            newsSidebar.classList.remove('is-scrolled');
        }
    }

    // Add scroll event listener
    window.addEventListener('scroll', handleScrollTransparency, { passive: true });
    // Initialize correct state on load
    handleScrollTransparency();

    // Export for external use
    window.toggleNewsSidebar = toggleNewsSidebar;
});
